module.exports = __webpack_public_path__ + "9cc298c8c86b195f238cf9ce3005211b.svg";